import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import { useNavigate, useParams } from "react-router-dom";
import { editClient, getOneClient, getAllServices } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { IoIosArrowBack } from "react-icons/io";
import { BsSave } from "react-icons/bs";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const EditClient = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const client = useSelector((state) => state.auth.client);
  const services = useSelector((state) => state.auth.allServices);

  useEffect(() => {
    async function func() {
      try {
        if (token) await dispatch(getAllServices(token));
      } catch (err) {
        console.error("Error fetching all services:", err);
      }
    }
    func();
  }, [dispatch, token]);

  const [formData, setFormData] = useState({
    name: "",
    businessName: "",
    email: "",
    clientType: "",
    phoneNumber: "",
    password: "",
    opted: [],
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      opted: selectedOptions,
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [id]: numericValue });
      }
    } else if (id === "name") {
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [id]: lettersOnly });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleSetDefaultPassword = () => {
    const cleanName = (formData.name || "").replace(/\s+/g, "");
    const lastDigits = formData.phoneNumber && formData.phoneNumber.length >= 5 ? formData.phoneNumber.slice(-5) : (formData.phoneNumber || "");
    setFormData((prev) => ({
      ...prev,
      password: cleanName + lastDigits,
    }));
    setShowPassword(true);
  };

 useEffect(() => {
  if (client) {
    setFormData({
      name: client?.name || "",
      businessName: client?.businessName || "", // Ensure this matches backend key
      email: client?.email || "",
      clientType: client?.clientType || "",
      phoneNumber: client?.phoneNumber || "",
      password: "",
      opted: client?.services?.map((service) => ({
        value: service._id,
        label: service.name,
      })) || [],
    });
  }
}, [client]);

  useEffect(() => {
    async function func() {
      try {
        await dispatch(getOneClient(id));
      } catch (err) {
        console.error("Error fetching client data:", err);
      }
    }
    func();
  }, [id, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        opted: formData.opted.map((option) => option.value),
      };
      if (!payload.password || payload.password.trim() === "") {
        delete payload.password;
      } else {
        payload.password = payload.password.trim();
      }
      await dispatch(editClient(token, payload, id));
      navigate("/client-management");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleBack = () => {
    navigate(`/client-management`);
  };

  const serviceOptions = services && services?.map((service) => ({ value: service._id, label: service.name }));

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#f9fafb',
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
      borderRadius: '8px',
      padding: '2px',
      fontSize: '14px',
      minHeight: '38px',
      '&:hover': {
        borderColor: '#3b82f6',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#dbeafe',
      borderRadius: '12px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#1e40af',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#eff6ff' : 'white',
      color: '#1f2937',
      fontSize: '14px',
      '&:active': {
        backgroundColor: '#dbeafe',
      },
    }),
  };

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar />
      <MainSection>
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Edit Client</h1>
            <div className="flex space-x-2">
              <button
                onClick={handleBack}
                className="flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                <IoIosArrowBack />
                <span>Back</span>
              </button>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Client Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition-colors"
                      placeholder="Enter Client name"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="companyName" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="businessName"
                      value={formData.businessName}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition-colors"
                      placeholder="Enter Company name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition-colors"
                      placeholder="Enter email address"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="clientType" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Client Type
                    </label>
                    <select
                      id="clientType"
                      value={formData.clientType}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    >
                      <option disabled value="">Select client Type</option>
                      <option value="Private Limited">Private Limited</option>
                      <option value="Partnership">Partnership</option>
                      <option value="Proprietorship">Proprietorship</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="phoneNumber" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      placeholder="Enter Phone number"
                      required
                    />
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <label htmlFor="password" className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                        Change Password
                      </label>
                      <button
                        type="button"
                        onClick={handleSetDefaultPassword}
                        className="text-xs text-blue-600 hover:text-blue-800 font-medium underline"
                      >
                        Use Default Password
                      </button>
                    </div>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10 transition-colors font-mono"
                        placeholder="Leave blank to keep current password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                        title={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <AiOutlineEyeInvisible size={18} /> : <AiOutlineEye size={18} />}
                      </button>
                    </div>
                    <p className="mt-1 text-[11px] text-gray-500">
                      Leave blank to keep current password, or enter a new password / click "Use Default Password" to reset.
                    </p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <label htmlFor="service" className="block mb-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                      Services
                    </label>
                    <Select
                      id="opted"
                      options={serviceOptions}
                      isMulti
                      onChange={handleSelectChange}
                      value={formData.opted}
                      styles={selectStyles}
                      className="text-sm"
                      placeholder="Select services"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-8 flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={handleBack}
                  className="flex items-center space-x-2 px-6 py-2 border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors"
                >
                  <span>Cancel</span>
                </button>
                <button
                  type="submit"
                  className="flex items-center space-x-2 px-6 py-2 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  <BsSave />
                  <span>Save Changes</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </MainSection>
    </div>
  );
};

export default EditClient;